import React from 'react';
import PropTypes from 'prop-types';

import { IconContext } from 'react-icons';
import {
  PiArrowFatLinesUpFill,
  PiArrowSquareOutBold,
  PiCheckFatFill,
  PiCopyBold,
  PiListDashesFill,
  PiWarningFill,
  PiXBold,
  PiArrowClockwiseBold,
  PiArrowsOutBold,
  PiCaretDownBold,
  PiCaretUpBold,
} from 'react-icons/pi';
import {
  RxTriangleRight,
  RxTriangleLeft,
  RxTriangleUp,
  RxTriangleDown,
} from 'react-icons/rx';

import Colors from 'shared/colors';

const components = {
  check: PiCheckFatFill,
  close: PiXBold,
  copy: PiCopyBold,
  external: PiArrowSquareOutBold,
  list: PiListDashesFill,
  upgrade: PiArrowFatLinesUpFill,
  warning: PiWarningFill,
  refresh: PiArrowClockwiseBold,
  triangleRight: RxTriangleRight,
  triangleLeft: RxTriangleLeft,
  triangleUp: RxTriangleUp,
  triangleDown: RxTriangleDown,
  expand: PiArrowsOutBold,
  toggleOpen: PiCaretDownBold,
  toggleClose: PiCaretUpBold,
};

const Icon = ({ name, size, color, fill, shadow, ...rest }) => {
  const IconComponent = components[name];

  if (!IconComponent) {
    throw new Error(`Icon does not have a definition for name "${name}"`);
  }

  const colorToUse = color || fill;

  const iconValues = React.useMemo(
    () => {
      let style;
      if (shadow) {
        style = {
          filter: 'drop-shadow(2px 1px 2px rgb(0 0 0 / 0.6))',
        };
      }
      return {
        size,
        color: colorToUse,
        style,
      };
    },
    [name, size, color, shadow],
  );

  return (
    <IconContext.Provider
      value={iconValues}
    >
      <IconComponent
        {...rest}
      />
    </IconContext.Provider>
  );
};

Icon.propTypes = {
  name: PropTypes.string.isRequired,
  size: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  color: PropTypes.string,
  fill: PropTypes.string,
  shadow: PropTypes.bool,
};

Icon.defaultProps = {
  size: '1em',
  color: Colors.white,
  fill: null,
  shadow: false,
};

export default Icon;
